import { route } from '../helpers';

import { NREPages } from '../../constants/AppConstants';

export default route(NREPages.ORDER_LANDING, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/nre/OrderLanding').default);
        }, 'nre-order-landing');
    }
});
